export default __webpack_public_path__ + "static/media/image25.79cf2bb6.jpg";